/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
  Input,
  Select,
  InputNumber,
  Radio, 
} from "antd";
import './index.scss';

const { TextArea } = Input;
const { Option } = Select;

const TrialSummary = (props) => {
  const { handleNewTrialInputChange, handleNewTrialSelectChange, handleValidation, updateDetail, indicationTherapeuticMap, handleCycleBasedInputReset, resetErrorMessage} = props

  let newTrial 
  if(Object.keys(JSON.parse(localStorage.getItem('newTrial'))).length !== 0) {
    newTrial = JSON.parse(localStorage.getItem('newTrial'))
  } else {
    newTrial = props.newTrial
  }

  

  const [indicationList, setIndicationList] = useState([])
  const [hasTemplateScenario, setHasTemplateScenario] = useState(false);
  const [isOncology, setIsOncology] = useState(newTrial.oncology_flag);
  const [isCycleBased, setIsCycleBased] = useState(newTrial.cycle_based_trial_flag);
  // useEffect(() => {
  //   let therapeuticAreaVal = newTrial["therapeutic_area"]
  //   if(!Array.isArray(therapeuticAreaVal)) { 
  //     therapeuticAreaVal = [therapeuticAreaVal];
  //   }
  //   if (therapeuticAreaVal.length == 1 && therapeuticAreaVal[0]=="All") {
  //     setIndicationList(sortIndication(props.indicationList))
  //   } else {
  //     let indications = []
  //     therapeuticAreaVal.forEach(ta => indications = indicationTherapeuticMap[ta] != undefined ? indications.concat(indicationTherapeuticMap[ta]) : indications)
  //     setIndicationList(sortIndication(indications))
  //   }

  //   newTrial.scenarios?.forEach((scenario) => {
  //     if (scenario.is_template) {
  //       setHasTemplateScenario(true);
  //     }
  //   });
  // }, [props])

  const oncologyChangeHandler = (v) => { 
    const value = v.target.value;
    handleNewTrialInputChange("oncology_flag", v) 
    if(value) {
      handleNewTrialSelectChange("therapeutic_area", 'Oncology')
      handleNewTrialInputChange("cycle_based_trial_flag", v)
      setIsCycleBased(true)
    } else {
      handleNewTrialSelectChange("therapeutic_area", '') 
      
      handleNewTrialInputChange("days_per_cycle", null)
      handleNewTrialInputChange("treatment_duration_months", null) 
      handleCycleBasedInputReset("cycle_based_trial_flag", null)
    } 
    setIsOncology(value)
    resetErrorMessage()
  }

  // const  onCycleChangeHandler = (v) => {
  //   const val = v.target.value 
  //   handleNewTrialInputChange("cycle_based_trial_flag", v)
  //   if(!val) {
  //     handleNewTrialInputChange("days_per_cycle", null)
  //   }
  //   setIsCycleBased(val)
  // }
  useEffect(() => {
    setIsOncology(props.newTrial.oncology_flag)
  }, [props.newTrial.oncology_flag])

  useEffect(() => {
    setIsCycleBased(props.newTrial.cycle_based_trial_flag)
  }, [props.newTrial.cycle_based_trial_flag])

  useEffect(() => {
    let therapeuticAreaVal = newTrial["therapeutic_area"];
    if (therapeuticAreaVal === "All") {
      setIndicationList(sortIndication(props.indicationList));
    } else {
      let indications = indicationTherapeuticMap[therapeuticAreaVal] !== undefined ? indicationTherapeuticMap[therapeuticAreaVal] : [];
      setIndicationList(sortIndication(indications));
    }
    newTrial.scenarios?.forEach((scenario) => {
      if (scenario.is_template) {
        setHasTemplateScenario(true);
      }
    });
  }, [props]);
  
  const sortIndication = (indicationList) => {
    return indicationList&&indicationList.sort((ind1, ind2) => (ind1.label < ind2.label) ? -1 : (ind1.label > ind2.label) ? 1 : 0);
  }

  const disableIndication = () => {
      if(newTrial['therapeutic_area'].length <1){
         return true;
      }else{
         return localStorage.getItem('user_type')?.toUpperCase() === 'ADMIN' || !updateDetail || (newTrial?.trial_user_role === "Edit" && !hasTemplateScenario) ? false : true;
      }
  }

  const disableAlias = () => {
       return localStorage.getItem('user_type')?.toUpperCase() === 'ADMIN' || !updateDetail ? false : true;
  }

  return (
    <div className="trial-summary-container">
      <div className="trials-basic-info">
        <div className="trial-item">
          <label htmlFor="">Trial title  <span className="required">*</span> </label>
          <Input
            style={{ width: "100%", height: 30 }}
            onBlur={(v) => handleValidation("trial_title", v)}
            onChange={(v) => handleNewTrialInputChange("trial_title", v)}
            value={newTrial["trial_title"]}
          />
          <span className="trial-summary-error">{props.trialTitleError}</span>
          <br/>
        </div>
        <div className="trial-item">
          <label htmlFor="">Description</label>
          <TextArea
            onChange={(v) => handleNewTrialInputChange("description", v)}
            value={newTrial["description"]}
            onBlur={(v) => handleValidation("description", v)}
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
            <br/>
            <span className="trial-summary-error">{props.descriptionError}</span>
        </div> 
        <div className="trial-item">
          <label className="oncology-selection trial-type-label" htmlFor="">Trial type</label> 
          <Radio.Group 
            value={newTrial.oncology_flag || false}
            buttonStyle="solid"
            onChange={(v) => oncologyChangeHandler(v)} 
            disabled={updateDetail}
            >
            <Radio.Button className="oncology-selection" value={false}>Non-oncology</Radio.Button>
            <Radio.Button className="oncology-selection" value={true}>Oncology</Radio.Button> 
          </Radio.Group> 
        </div>
        <div className="parallel-item ">
          <div className="trial-item">
            <label>Therapeutic area  <span className="required">*</span> </label>
            <Select
              // mode="multiple"
              className="therapeutic-area-select"
              value={newTrial["therapeutic_area"]}
              virtual={false}
              // showSearch
              style={{ width: '550px'}}
              onBlur={(v) => handleValidation("therapeutic_area", v)}
              disabled={updateDetail || newTrial["therapeutic_area"] === 'Oncology' ? true : false}  
              onChange={(v) =>
                handleNewTrialSelectChange("therapeutic_area", v)
              }
              filterOption={(input, option) =>
                option.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0  
              }  
            >
              {props.therapeuticAreaList.filter(k => k !== "Oncology").map((o) => {
                return (
                  <Option value={o} key={o}>
                    {o}
                  </Option>
                );
              })}
            </Select>
            <br/>
            <span className="trial-summary-error">{props.therapeuticAreaError}</span>
          </div>
          <div className="trial-item">
            <label htmlFor="">Indication  <span className="required">*</span> </label>
            <Select
              mode="multiple"
              className="indication-area-select"
              allowClear
              showSearch
              value={newTrial["indication"]}
              style={{ width: '550px' }}
              virtual={false}
              disabled={ disableIndication()}
              onBlur={(v) => handleValidation("indication", v)}
              onChange={(v) => handleNewTrialSelectChange("indication", v)}
              filterOption={(input, option) =>
                option.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {indicationList.map((t) => {
                return (
                  <Option value={t.value} key={t.value}>
                    {t.label}
                  </Option>
                );
              })}
            </Select>
            <br/>
            {newTrial.scenarios.find(s=> s.is_template) && (
              <div className="indication-warning">
                <span className="asterisk">*</span>
                This trial has a scenario marked as template. Changing trial properties will have downstream effects!
              </div>
            )}
            <span className="trial-summary-error">{props.indicationError}</span>
          </div>
        </div>
        <div className="parallel-item">
          <div className="trial-item">
            <label htmlFor="">Trial alias  <span className="required">*</span> </label>
            <Input
              style={{ width: '550px', height: 30 }}
              onBlur={(v) => handleValidation("trial_alias", v)}
              onChange={(e) => handleNewTrialInputChange("trial_alias", e)}
              value={newTrial["trial_alias"]}
              disabled={ disableAlias()}
            />
            <br/>
            <span className="trial-summary-error">{props.trialAliasError}</span>
          </div>
          <div className="trial-item">
            <label htmlFor="">Study type</label>
            <Select
              mode="multiple"
              allowClear
              showSearch
              value={newTrial["study_type"]}
              style={{ width: '550px' }}
              virtual={false}
              onChange={(v) => handleNewTrialSelectChange("study_type", v)}
              filterOption={(input, option) =>
                option.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {props.studyTypeList.map((t) => {
                return (
                  <Option value={t.value} key={t.value}>
                    {t.label}
                  </Option>
                );
              })}
            </Select>
          </div>
        </div>
        <div className="parallel-item">
          <div className="trial-item">
            <label htmlFor="">Molecule name</label>
            <Input
              style={{ width: '550px', height: 30 }}
              onBlur={(v) => handleValidation("molecule_name", v)}
              onChange={(v) =>
                handleNewTrialInputChange("molecule_name", v)
              }
              value={newTrial["molecule_name"]}
            />
            <br/>
            <span className="trial-summary-error">{props.moleculeNameError}</span>
          </div>
          <div className="trial-item">
            <label htmlFor="">Study phase</label>
            <Select
              mode="multiple"
              allowClear
              showSearch
              value={newTrial["study_phase"]}
              style={{ width: '550px' }}
              virtual={false}
              // dropdownMatchSelectWidth={false}
              onChange={(v) => handleNewTrialSelectChange("study_phase", v)}
              filterOption={(input, option) =>
                option.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {props.studyPhaseList.map((o) => {
                return (
                  <Option value={o.value} key={o.value}>
                    {o.label}
                  </Option>
                );
              })}
            </Select>
          </div>
        </div>
        <div className="parallel-item">
          <div className="trial-item">
            <label htmlFor="">Pediatric study</label>
            <Select
                className="pediatric-study-select"
                value={newTrial["pediatric_study"] === null ? "null" : newTrial["pediatric_study"].toString()}
                style={{ width: '550px' }}
                onChange={(v) =>
                handleNewTrialSelectChange("pediatric_study", v)
                }
            >
              <Option value="null">All</Option>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </div>
          <div className="trial-item">
            <label htmlFor="">Estimated enrollment  <span className="required">*</span> </label>
            <InputNumber
              step={1}
              style={{ width: 550, height: 30 }}
              onBlur={(v) => handleValidation("estimated_enrollment_count", v)}
              onChange={(e) => handleNewTrialInputChange("estimated_enrollment_count", e)}
              value={newTrial["estimated_enrollment_count"]}
            />
            <br/>
          <div style={{ maxWidth: '550px' }}>
            <span className="trial-summary-error">{props.estimatedTotalError}</span>
          </div>
          </div>
          {/* <div className="trial-item">
            <label htmlFor="">Study Country</label>
            <Select
              defaultValue="All"
              value={newTrial["study_country"]}
              style={{ width: 250 }}
              onChange={(v) =>
                handleNewTrialSelectChange("study_country", v)
              }
            >
              {props.studyCountryList.sort().map((o) => {
                return (
                  <Option value={o.value} key={o.value}>
                    {o.label}
                  </Option>
                );
              })}
            </Select>
          </div> */}
        </div>

        <div className="parallel-item">
          <div className="trial-item">
            <label htmlFor="">Number of arms <span className="required">*</span> </label>
            <InputNumber
              step={1}
              style={{ width: 550, height: 30 }}
              onBlur={(v) => handleValidation("number_of_arms", v)}
              onChange={(e) => handleNewTrialInputChange("number_of_arms", e)}
              value={newTrial["number_of_arms"]}
            />
             <br/>
            <span className="trial-summary-error">{props.numberOfArmsError}</span>
          </div>

          {isOncology ? (<div className="trial-item">
            <label htmlFor="">Cycle length (days) <span className="required">*</span> </label>
            <InputNumber
              step={1}
              style={{ width: 550, height: 30 }}
              onBlur={(v) => handleValidation("days_per_cycle", v)}
              onChange={(e) => handleNewTrialInputChange("days_per_cycle", e)}
              value={newTrial["days_per_cycle"]} 
              disabled={!isCycleBased}
            />
             <br/>
            <span className="trial-summary-error">{props.daysPerCycle}</span>
          </div>) : (
            <div className="trial-item">
            <label htmlFor="">Length of treatment period (In weeks)  <span className="required">*</span> </label>
            <InputNumber
              step={1}
              style={{ width: 550, height: 30 }}
              onBlur={(v) => handleValidation("treatment_duration", v)}
              onChange={(e) => handleNewTrialInputChange("treatment_duration", e)}
              value={newTrial["treatment_duration"]}
            />
            <br/>
            <span className="trial-summary-error">{props.lengthOfTreatMentError}</span>
          </div>
          )}
          
          
        </div>

        <div className="parallel-item">
          {isOncology  && (
            <>
            {/* <div className="trial-item">
              <label htmlFor="">Cycle Based Trials <span className="required">*</span> </label>
              <Radio.Group 
                onChange={onCycleChangeHandler} 
                defaultValue={newTrial.cycle_based_trial_flag} 
                disabled={updateDetail}
                >
                <Radio className="horizontal-radio" value={true}>Yes</Radio>
                <Radio className="horizontal-radio" value={false}>No</Radio>
                
              </Radio.Group>
              <br/>
              <span className="trial-summary-error">{props.cycleBasesTrial}</span>
          </div> */}
           <div className="trial-item">
           <label htmlFor="">Expected time on treatment per patient (months)  <span className="required">*</span> </label>
           <InputNumber
             step={0.01}
             style={{ width: 550, height: 30 }}
             onBlur={(v) => handleValidation("treatment_duration_months", v)}
             onChange={(e) => handleNewTrialInputChange("treatment_duration_months", e)}
             value={newTrial["treatment_duration_months"]}
           />
           <br/>
           <span className="trial-summary-error">{props.estimatedDuration}</span>
         </div>
         </>
          )}
          
          
          
        </div>
      </div>
    </div>
  )
}

export default TrialSummary;